export class PublicCompany {
	public Id: string;
	public Name: string;
	public VatNumber: string;
	public CountryCode: string;
	public LanguageCode: string;
	public TimeZone: string;
}
